import React, { useContext } from "react";
import NextBar from "../NextBar/NextBar";
import RegistrationSummary from "../RegistrationSummary/RegistrationSummary";


interface WhiteBoxLayoutProps {
  title: string;
  children?: React.ReactNode;
  handleSelect?: () => void;
  disableNext?: boolean;
}

const WhiteBoxLayout: React.FC<WhiteBoxLayoutProps> = (props) => {
  const buttonDisabled = props.disableNext && true;

  return (
    <div className="container mx-auto px-4 py-8 flex flex-col overflow-y-scroll h-full flex-grow-1">

      <div className="bg-white rounded-xl shadow-lg flex flex-col flex-1 py-6">
        <div className="w-full max-w-6xl mx-auto bg-white p-4 rounded-lg flex flex-col justify-between h-full">
          <div>
            {props.children}
          </div>
          <div className="mt-12">
            <RegistrationSummary
            />
          </div>
        </div>
      </div>
      {props.handleSelect && <NextBar disabled={buttonDisabled} handleSelect={props.handleSelect} />}
    </div>
  );
};

export default WhiteBoxLayout;
